import React from "react";
import { MessageSquareText } from "lucide-react";
import OnboardingSectionCard from "@/features/onboarding/components/OnboardingSectionCard";
import { ChipInput } from "@/shared/components/ui/Input/chipInput";
import {
  CAMPAIGN_MESSAGE_STYLE_OPTIONS,
  MAX_CAMPAIGN_MESSAGE_STYLES,
} from "@/shared/utils/aiConfig";

const MESSAGE_STYLE_DROPDOWN_OPTIONS = CAMPAIGN_MESSAGE_STYLE_OPTIONS.map(
  (option) => ({
    label: option.title,
    value: option.key,
    description: option.description,
  }),
);

const CampaignMessageStyleStep = ({ value = [], onChange, error = null }) => {
  const selectedKeys = Array.isArray(value) ? value : [];

  return (
    <div className="w-full flex flex-col space-y-8 scrollbar-hide">
      <OnboardingSectionCard
        icon={<MessageSquareText className="text-gray-500" size={20} />}
        title="Messaging style"
      >
        <ChipInput
          defaultChips={selectedKeys}
          placeholder="Select messaging styles"
          secondaryPlaceholder="Add another style…"
          dropdownOptions={MESSAGE_STYLE_DROPDOWN_OPTIONS}
          onChange={onChange}
          maxChips={MAX_CAMPAIGN_MESSAGE_STYLES}
          allowCustomChips={false}
          showOptionDescription
          showChipTooltip
          errors={error}
        />
        {error ? <p className="text-red-500 text-xs mt-1">{error}</p> : null}
      </OnboardingSectionCard>
    </div>
  );
};

export default CampaignMessageStyleStep;
